import { callAssetSearch } from '../search/search.js';
export function registerCreateExtraAlertEvents(obj, jsobj) {

	obj.ready(function () {

		$('.check-toggle').bootstrapToggle();
		
		$('#searcharea').css("display", "none");
		$("#assetSelection").css("display", "block");
		if (jsobj['alertid']) {
			var id = jsobj['alertid'];
			if (useralerts[id]['currency']) $(".asset-currency").each(function () { $(this).val(useralerts[id]['currency'].toCurrencySymbol()) });
			if (useralerts[id]['symbol']) $('#alert_stockid').html(useralerts[id]['symbol']);
			if (useralerts[id]['name']) $('#alert_stockname').html(useralerts[id]['name']);
			if (useralerts[id]['assettype']) $('#asset_type').html(useralerts[id]['assettype']);
			if (useralerts[id]['assettype'] == "CoreCommodityAsset") $("#oz-sign").css("display", "block");

			if (useralerts[id]['startprice']) $('#myAssetStartPrice').val(useralerts[id]['startprice']);
			if (useralerts[id]['amount']) $('#myAssetAmount').val(useralerts[id]['amount']);
			if (useralerts[id]['timeframe']) $('#alert_timeframe').val(useralerts[id]['timeframe']);
			if (useralerts[id]['delta']) {
				if (useralerts[id]['delta'] >= 0) $('#alert_delta').val(useralerts[id]['delta']);
				if (useralerts[id]['delta'] < 0) $('#alert_delta').val(useralerts[id]['delta'] * -1);
			}
			if (useralerts[id]['absolutevalue']) $('#absolute_value').val(useralerts[id]['absolutevalue']);
			if (useralerts[id]['type'] == "Alertabsolute") {
				$('#radioBtn .btn:eq(1)').click();
			}
			if (useralerts[id]['delta'] > 0) {
				$('#dropdown-menu-create-02 li:nth-child(2) a').click();
				$('#alert_delta').click();
				$("#searchstring").focus();
			}
		}
		if (jsobj['assetid']) {
			var id = jsobj['assetid'];
			selectors.setSelectedAsset(userassets[id].core_asset_id);
    		if (userassets[id]['symbol']) $('#alert_stockid').html(userassets[id]['symbol']);
			if (userassets[id]['name']) $('#alert_stockname').html(userassets[id]['name']);
		    if (userassets[id]['assettype']) $('#asset_type').html(userassets[id]['assettype']);
			if (userassets[id]['assettype'] == "CoreCommodityAsset") $("#oz-sign").css("display", "block");
			if (userassets[id]['currency']) $(".asset-currency").each(function () { $(this).val(userassets[id]['currency'].toCurrencySymbol()) });
		}
	});

	$("#kpi_200_checked").parent().on("click", ()=> {
		$('#kpi_50_checked').is(':checked') ? $("#kpi_50_checked").parent().click() : null
	})

	$("#kpi_50_checked").parent().on("click", ()=> {
		$('#kpi_200_checked').is(':checked') ? $("#kpi_200_checked").parent().click() : null
	})

	$('#radioBtn a').on('click', function () {

		if (jsobj['alertid'] && useralerts[jsobj['alertid']]['lessthan'] == true) $('#dropdown-menu-create-01 li:nth-child(2) a').click();

		var sel = $(this).data('title');
		var tog = $(this).data('toggle');
		$('#' + tog).prop('value', sel);
		$('#abs').removeClass('active');
		$('#delta').removeClass('active');
		$('#kpis').removeClass('active');
		if (sel === "ABS") $('#abs').addClass('active');
		if (sel === "DELTA") $('#delta').addClass('active');
		if (sel === "KPI") $('#kpis').addClass('active');
		$("#data-alert-switch").attr('data-at', sel);
		var deltaabs = sel;
		$('a[data-toggle="' + tog + '"]').not('[data-title="' + sel + '"]').removeClass('active').addClass('notActive');
		$('a[data-toggle="' + tog + '"][data-title="' + sel + '"]').removeClass('notActive').addClass('active');
	});
	$("#dropdown-menu-create-01 li a").click(function () {
		$("#dropdown-toggle-create-01").html($(this).text() + ' <span class="caret"></span>');
		$("#data-alert-switch").attr('data-aas', $(this).data('set'));
		$("#dropdown-toggle-create-01").click();
		return false;
	});
	$("#dropdown-menu-create-02 li a").click(function () {
		$("#dropdown-toggle-create-02").html($(this).text() + ' <span class="caret"></span>');
		$("#data-alert-switch").attr('data-ads', $(this).data('set'));
		$("#dropdown-toggle-create-02").click();
		return false;
	});

	callAssetSearch();
}
